// extracted by mini-css-extract-plugin
export default {"hide":"visually-hidden-text_hide"};